import React from "react";
import IconClose from "../Resources/svg/Icons/IconClose";
import ModalFiltering from "./FormElements/ModalFiltering";
import Button from "./FormElements/Button";

const ModalAlertLocationCode = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <ModalFiltering
      className={`modal-result is-midle ${open && "is-open"}`}
    >
      <div className="modal-filtering__close" onClick={onClose}>
        <IconClose />
      </div>
      <h2 className="modal-result__title">Datos incompletos</h2>
      <div className="modal-result__desc">
        <p>Faltan datos de ubigeo del asegurado o de los beneficiarios. Completa la información requerida para emitir.</p>
      </div>
      <div className="actions">
        <Button
          type="button"
          className="actions__continue"
          onClick={onClose}
        >
          Aceptar
        </Button>
      </div>
    </ModalFiltering>
  );
};

export default ModalAlertLocationCode;
